/*
 * This file is autogenerated by ./scripts/generateServicesConfig.ts.
 * DO NOT EDIT MANUALLY!
 */
/* eslint-disable prettier/prettier */
import type { SdkServicesConfig } from './types'
export const productionConfig: SdkServicesConfig = {
  "network": {
    "minVersion": "0.7.0",
    "apiEndpoint": "https://api.audius.co",
    "storageNodes": [
      {
        "endpoint": "https://creatornode.audius.co",
        "delegateOwnerWallet": "0xc8d0C29B6d540295e8fc8ac72456F2f4D41088c8"
      }
    ],
    "antiAbuseOracleNodes": {
      "endpoints": [
        "https://anti-abuse-oracle.audius.engineering",
        "https://audius-oracle.creatorseed.com",
        "https://oracle.audius.endl.net"
      ],
      "registeredAddresses": [
        "0x9811BA3eAB1F2Cd9A2dFeDB19e8c2a69729DC8b6",
        "0xe60d50356cd891f56B744165fcc1D8B352201A76",
        "0x7A03cFAE79266683D9706731D6E187868E939c9C"
      ]
    },
    "identityService": "https://identityservice.audius.co"
  },
  "acdc": {
    "entityManagerContractAddress": "0x1Cd8a543596D499B9b6E7a6eC15ECd2B7857Fd64",
    "chainId": 31524
  },
  "solana": {
    "claimableTokensProgramAddress": "Ewkv3JahEFRKkcJmpoKB7pXbnUHwjAyXiwEo4ZY2rezQ",
    "rewardManagerProgramAddress": "DDZDcYdQFEMwcu2Mwo75yGFjJ1mUQyyXLWzhZLEVFcei",
    "rewardManagerStateAddress": "71hWFVYokLaN1PNYzTAWi13EfJ7Xt9VbSWUKsXUT8mxE",
    "paymentRouterProgramAddress": "paytYpX3LPN98TAeen6bFFeraGSuWnomZmCXjAsoqPa",
    "stakingBridgeProgramAddress": "stkB5DZziVJT1C1VmzvDdRtdWxfs5nwcHViiaNBDK31",
    "rpcEndpoint": "https://carolina-8qh733-fast-mainnet.helius-rpc.com",
    "usdcTokenMint": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    "wAudioTokenMint": "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
    "rewardManagerLookupTableAddress": "4UQwpGupH66RgQrWRqmPM9Two6VJEE68VZ7GeqZ3mvVv"
  },
  "ethereum": {
    "rpcEndpoint": "https://eth-client.audius.co",
    "addresses": {
      "ethRewardsManagerAddress": "0x5aa6B99A2B461bA8E97207740f0A689C5C39C3b0",
      "serviceProviderFactoryAddress": "0xD17A9bc90c582249e211a4f4b16721e7f65156c8",
      "serviceTypeManagerAddress": "0x9EfB0f4F38aFbb4b0984D00C126E97E21b8417C5",
      "audiusTokenAddress": "0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998",
      "audiusWormholeAddress": "0x6E7a1F7339bbB62b23D44797b63e4258d283E095",
      "delegateManagerAddress": "0x4d7968ebfD390D5E7926Cb3587C39eFf2F9FB225",
      "stakingAddress": "0xe6D97B2099F142513be7A2a068bE040656Ae4591",
      "governanceAddress": "0x4DEcA517D6817B6510798b7328F2314d3003AbAC",
      "claimsManagerAddress": "0x44617F9dCEd9787C3B06a05B35B4C779a2AA1334",
      "trustedNotifierManagerAddress": "0x6f08105c8CEef2BC5653640fcdbBE1e7bb519D39",
      "registryAddress": "0xd976d3b4f4e22a238c1A736b6612D22f17b6f64C"
    }
  }
}
